import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./Portfolio";
import Travel from "./Travel";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/travel" element={<Travel />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
